import { ShopwareMessageTypePrivileges } from '.';
export function sendPrivileged(messageType) {
    const requiredPrivileges = getRequiredPrivilegesForMessage(messageType);
    const locationPriviliges = getLocationPrivileges(window.location);
    if (!requiredPrivileges || Object.keys(requiredPrivileges).length <= 0) {
        return null;
    }
    return getMissingPrivileges(requiredPrivileges, locationPriviliges);
}
export function handlePrivileged(messageType, extensions, origin) {
    const requiredPrivileges = getRequiredPrivilegesForMessage(messageType);
    const extension = findExtensionByBaseUrl(extensions, origin);
    if (!extension) {
        return null;
    }
    return getMissingPrivileges(requiredPrivileges, extension.permissions);
}
function getRequiredPrivilegesForMessage(messageType) {
    var _a;
    return (_a = ShopwareMessageTypePrivileges[messageType]) !== null && _a !== void 0 ? _a : {};
}
function getLocationPrivileges(location) {
    const params = new URLSearchParams(location.search);
    const privilegeString = params.get('privileges');
    if (!privilegeString) {
        return {};
    }
    const privileges = JSON.parse(privilegeString);
    return privileges;
}
function getMissingPrivileges(requiredPrivileges, privileges) {
    const requiredRoles = Object.keys(requiredPrivileges);
    const missingPriviliges = [];
    // Compare detailed priviliges of each role and add missing to stack
    requiredRoles.forEach((requiredRole) => {
        var _a;
        (_a = requiredPrivileges[requiredRole]) === null || _a === void 0 ? void 0 : _a.forEach((privilege) => {
            var _a;
            if (!((_a = privileges[requiredRole]) === null || _a === void 0 ? void 0 : _a.includes(privilege))) {
                missingPriviliges.push(`${requiredRole}:${privilege}`);
            }
        });
    });
    return missingPriviliges.length >= 1 ? missingPriviliges : null;
}
function findExtensionByBaseUrl(extensions, baseUrl) {
    let extension = null;
    Object.values(extensions).forEach((ext) => {
        if (ext.baseUrl === baseUrl) {
            extension = ext;
        }
    });
    return extension;
}
//# sourceMappingURL=privilege-resolver.js.map